import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import Link from 'next/link';
import { useGetRewardFaq } from 'entity/reward/rewardHooks';

export const FaqItem = (props: { question: string; answer: string }) => {
  const { question, answer } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="flex flex-col gap-2 w-full cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex justify-between w-full">
        <p>{question} </p>
        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </div>
      {isOpen && <p className="text-neutral-500">{answer} </p>}
    </div>
  );
};

const RewardFaq = () => {
  const faqs = useGetRewardFaq();

  return (
    <div className="p-4 bg-white rounded w-full">
      <div className="flex flex-col w-full gap-4">
        <p className="text-sm font-bold">FAQs</p>
        <div className="flex flex-col gap-4 items-center w-full">
          {faqs.slice(0, 5).map(faq => (
            <FaqItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
        <Link href="/rewards/faq" passHref>
          <a className="hover:text-blue-500">See All</a>
        </Link>
      </div>
    </div>
  );
};

export default RewardFaq;
